import SaveButton from "@/components/button/save-button";
import { ProfilePageContainer } from "@/components/container/profile-page-container";
import { PageTitleComponent } from "@/components/page-title";
import { RecreatePlanAlert } from "@/features/settings/components/recreate-plan-alert";
import { useToast } from "@/hooks/ui/use-toast";
import { useIonRouter } from "@ionic/react";
import { useState } from "react";
import SupermarketSelectionList from "../../components/supermarket-selection-list";
import { useSupermarket } from "../../hooks/use-supermarket";

export default function SettingLifestyleSupermarketPage() {
  const navigation = useIonRouter();
  const [isOpen, setIsOpen] = useState(false);
  const { showSuccess } = useToast();
  const {
    selectedOptions,
    handlePreferenceSelect,
    handleSubmit,
    isLoading,
    isUpdating,
    options,
  } = useSupermarket({
    onSuccess: () => {
      setIsOpen(true);
    },
  });

  const handleCancel = () => {
    setIsOpen(false);
    navigation.goBack();
  };
  const handleRecreatePlan = () => {
    setIsOpen(false);
    showSuccess("Recreate plan successful");
    navigation.goBack();
  };

  return (
    <ProfilePageContainer>
      <PageTitleComponent
        title="Which supermarket you shop at?"
        description="We’ll tailor your companion around the places you already go."
        className="mt-2 mb-6 w-full"
      />

      <SupermarketSelectionList
        isLoading={isLoading}
        options={options ?? []}
        selectedPreference={selectedOptions}
        handlePreferenceSelect={handlePreferenceSelect}
      />

      <SaveButton
        position="fixed"
        text="Save"
        onSave={handleSubmit}
        disabled={isLoading || isUpdating}
      />
      <RecreatePlanAlert
        isOpen={isOpen}
        onCancel={handleCancel}
        onConfirm={handleRecreatePlan}
      />
    </ProfilePageContainer>
  );
}
